import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const Field = ({ label, error, children, required }) => (
  <div className="space-y-1.5">
    <Label className="text-xs font-medium text-slate-600">
      {label}{required && <span className="text-rose-600">*</span>}
    </Label>
    {children}
    {error && <p className="text-xs text-rose-600">{error}</p>}
  </div>
);

export const TextField = ({ label, value, onChange, type = "text", error, required, placeholder, testId, disabled = false }) => (
  <Field label={label} error={error} required={required}>
    <Input
      value={value ?? ""}
      onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
      type={type}
      placeholder={placeholder}
      data-testid={testId}
      disabled={disabled}
    />
  </Field>
);

export const SelectField = ({ label, value, onChange, options, error, required, placeholder = "Select an option", testId, className = "", disabled = false }) => (
  <Field label={label} error={error} required={required}>
    <Select disabled={disabled} value={value != null ? String(value) : ""} onValueChange={(v) => onChange(v)}>
      <SelectTrigger className={`${error ? "border-rose-500 focus:ring-rose-500" : ""} ${className}`} data-testid={testId} disabled={disabled} aria-invalid={Boolean(error)}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={String(o.value)}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </Field>
);
